module.exports = __webpack_public_path__ + "static/media/arrow-back.c193fcd5.svg";